<template>
  <div class="analyze-upload">
    <UploadsProgress
      v-if="mobile"
      class="mt-6"
    />
    <slot />
    <TabBox
      :options="options"
      :tab="l_tab"
      idKey="id"
      style="
        flex: 1;
        --tbbox-content-clr-back: var(--clr-black-1-1);
        --tbbox-content-padding: 1rem 1rem;
      "
      tabsStyle="
    --height: 2.75rem;
    --height-inner: 3rem;
    --tab-fnt-size: 1rem;
    --tab-radius: 8px;
    --inner-flex: 1;
    --tab-flex: 1;
    --padding-inner: 0 2.5rem 0 0;
    --clr-tbbox-tab-back: transparent;
      "
      @click="item => (l_tab = item.id)"
    >
      <template #tab="{ item }">
        <div class="f-center w-100">
          <i
            v-if="item.icon"
            class="mdi text-large mr-2"
            :class="item.icon"
            :data-tst="`upload_tab_${item.id}`"
          />
          {{ $t(`tabs.${item.id}`) }}
        </div>
      </template>

      <template #default>
        <div
          v-if="!maintenanceFilesUpload && l_tab === 'single_hand'"
          class="analyze-upload_right"
        >
          <div
            v-show="!pasting && !loading"
            class="upload-container"
            data-tst="upload_container"
            @click="startPasting"
          >
            <i class="analyze-upload_icon mt-auto mdi mdi-content-copy" />
            <div class="text-message">
              {{ $t('upload.click_paste') }}
              <br />
              {{ $t('upload.hh_here') }}
            </div>
            <UploadBoxesSites class="mt-12" />
          </div>

          <div
            v-show="pasting"
            class="upload-container paste-text"
          >
            <textarea
              ref="paste_container"
              v-model="pasteText"
              data-tst="paste_container"
              contenteditable="true"
              @keydown.enter="analyze"
            ></textarea>
            <div
              v-if="!pasteText.length"
              class="text-area-help"
            >
              <div
                class="pa-1"
                v-html="$t('upload.help_copy')"
              ></div>
              <div
                class="pa-1"
                v-html="$t('upload.help_paste')"
              ></div>
              <div
                class="pa-1"
                v-html="$t('upload.help_enter_analyze')"
              ></div>
            </div>
          </div>

          <div
            v-show="loading"
            class="upload-container highlighted"
          >
            <div class="text-message anim-fade-in">
              {{ $t('upload.hh_is_analyzing') }}
            </div>
            <v-progress-circular
              data-tst="analyzing_loader"
              class="mt-6"
              :size="64"
              :model-value="80"
              :indeterminate="true"
            ></v-progress-circular>
          </div>

          <div
            class="gw_btn_primary gw_btn-v1 w-100 weight_500"
            :class="{ 'gw_btn_disabled no-events': loading }"
            style="--clr-disabled: var(--clr-grey-2)"
            data-tst="btn_analyze"
            @click="analyze"
          >
            {{ $t('btn.analyze') }}
          </div>
        </div>

        <div
          v-if="!maintenanceFilesUpload && l_tab === 'multiple_hand'"
          class="analyze-upload_left"
        >
          <form
            ref="upload_form"
            style="visibility: hidden; height: 0"
          >
            <input
              id="folder"
              ref="folder_input"
              style="visibility: hidden; height: 0"
              type="file"
              multiple
              webkitdirectory
              directory
              @change="handleFolderUpload"
            />

            <input
              id="file"
              ref="file_input"
              style="visibility: hidden; height: 0"
              data-tst="file_input"
              type="file"
              multiple
              @change="handleFileUpload"
            />
          </form>

          <GwMenu
            ref="gwmenu"
            style="margin: 0 0 1rem 0"
            class="flex-1"
            placement="bottom-end"
            :useVirtualElement="true"
          >
            <template #opener>
              <div
                :class="[
                  { 'upload-container_hovered': isDraggedOver },
                  {
                    'upload-disabled': nadaPurchased,
                  },
                ]"
                class="upload-container dashed h-100"
                data-tst="upload_container"
                @drop.prevent="handleDroppedFiles"
                @dragover.prevent
                @dragenter.prevent="isDraggedOver = true"
                @dragleave.prevent="isDraggedOver = false"
              >
                <i class="analyze-upload_icon mt-auto mdi-cloud-upload mdi" />
                <div
                  v-if="nadaPurchased"
                  class="text-message px-8 mb-auto"
                  data-tst="message_upload_disabled"
                >
                  {{ $t('upload.upload_members_only') }}
                  <br />
                  <v-btn
                    data-tst="upload_files_upgrade"
                    :to="{ name: 'Subscription' }"
                    color="primary"
                    size="large"
                    class="mt-6"
                  >
                    <i class="mr-2 mdi mdi-crown" />
                    {{ $t('btn.upgrade') }}</v-btn
                  >
                </div>
                <div
                  v-else
                  class="text-message"
                >
                  {{ $t('upload.drag_drop') }}
                  <br />
                  {{ $t('upload.hh_or_files_here') }}
                </div>

                <UploadBoxesSites
                  v-if="sub.plan.tier !== 'TRIAL' && sub.plan.tier !== 'FREE'"
                  class="mt-12"
                />
              </div>
            </template>
            <template #default="{ methods }">
              <GwBtns
                class="gw_menu gwbtns_vertical_white"
                style="--gwbtn-size: 1rem; --gwbtn-height: 2.5rem; --gwbtn-padding: 0 0.75rem"
                :options="[
                  {
                    text: $t('btn.upload_folder'),
                    icon: 'mdi-folder-upload',
                    fn: () => $refs.folder_input.click(),
                  },
                  {
                    text: $t('btn.upload_files'),
                    icon: 'mdi-file-upload',
                    fn: () => $refs.file_input.click(),
                  },
                ]"
                @click="
                  (_e, item) => {
                    methods.toggleOpen(false)
                    item.fn()
                  }
                "
              >
                <template #default="{ item }">
                  <div
                    class="mdi text-semi-large mr-2"
                    :class="item.icon"
                  ></div>
                  {{ item.text }}
                </template>
              </GwBtns>
            </template>
          </GwMenu>

          <div
            class="d-flex w-100"
            style="gap: 0.5rem"
          >
            <div
              class="gw_btn_primary gw_btn-v1 flex-1 weight_500"
              :class="{ 'gw_btn_disabled no-events': nadaPurchased }"
              style="--clr-disabled: var(--clr-grey-2)"
              @click="$refs.folder_input.click()"
            >
              <i class="mr-2 mdi-folder-upload text-normal-large mdi" />
              {{ $t('btn.btn_upload_folder') }}
            </div>

            <div
              class="gw_btn_primary gw_btn-v1 flex-1 weight_500"
              :class="{ 'gw_btn_disabled no-events': nadaPurchased }"
              style="--clr-disabled: var(--clr-grey-2)"
              @click="$refs.file_input.click()"
            >
              <i class="mr-2 mdi mdi-file-upload text-normal-large" />
              {{ $t('btn.btn_upload_files') }}
            </div>
          </div>
        </div>
        <div
          v-else-if="maintenanceFilesUpload"
          class="analyze-upload_left anim-fade-in no-events"
        >
          <div
            class="upload-container"
            style="border: 2px solid rgba(255, 255, 255, 0.1)"
          >
            <i class="mdi mdi-progress-wrench analyze-upload_icon mt-auto" />
            <div
              class="text-message px-8 mb-auto"
              v-html="$t('messages.upload_mainenance_tra01')"
            ></div>
          </div>
        </div>
      </template>
    </TabBox>
    <UploadBoxesLinks
      style="padding: 0.25rem 0 0 0"
      class="bt-greys mt-auto w-100"
    />
  </div>
</template>

<script>
import { nextTick } from 'vue'
import UploadsProgress from '@/components/AppBar/UploadsProgress'
import TabBox from '@/components/lib/TabBox'
import GwBtns from '@/components/lib/GwBtns'
import format_mix from '@/mixins/format_mix'
import { v4 as uuid } from 'uuid'
import { allSitesOptions } from '@/helpers/constants'

import tier_mix from '@/mixins/tier_mix'
import links_mix from '@/mixins/links_mix'
import UploadBoxesSites from '@/components/UploadBoxes/UploadBoxesSites'
import UploadBoxesLinks from '@/components/UploadBoxes/UploadBoxesLinks'
import GwMenu from '@/components/lib/GwMenu'

export default {
  name: 'UploadBoxes',
  components: {
    UploadBoxesSites,
    UploadBoxesLinks,
    UploadsProgress,
    TabBox,
    GwMenu,
    GwBtns,
  },
  mixins: [format_mix, tier_mix, links_mix],
  // mixins: [format_mix],
  props: {
    tab: { default: () => '' },
  },
  data() {
    return {
      // maintenanceFilesUpload: true,
      // maintenanceFilesUpload: false,
      pasting: false,
      pasteText: '',

      options: [
        // { id: 'single_hand', icon: 'mdi-cards-playing' },
        { id: 'single_hand', icon: 'mdi-upload' },
        { id: 'multiple_hand', icon: 'mdi-file-upload' },
      ],
      l_tab: 'single_hand',
      supportedSites: allSitesOptions(),
      isDraggedOver: false,
      maxFilesError: false,
      droppedFiles: [],
    }
  },
  created() {
    this.setUploadBox()
  },
  methods: {
    setUploadBox() {
      if (this.tab === 'multiple_hand') {
        this.l_tab = 'multiple_hand'
      }
    },
    // drag drop files .txt
    // drag drop files and folders together
    // drag drop recursive folders
    // folder select files (btn)
    // folder select recursive folders (btn)
    // https://stackoverflow.com/questions/18815197/javascript-file-dropping-and-reading-directories-asynchronous-recursion
    handleDroppedFiles(evt) {
      this.maxFilesError = false
      evt.preventDefault()
      const data = evt.dataTransfer.items

      const dataLength = data.length
      let files = 0
      for (let i = 0; i < data.length; i += 1) {
        const item = data[i]
        const entry = item.webkitGetAsEntry()
        if (entry?.isFile) {
          // eslint-disable-next-line no-loop-func
          entry.file(f => {
            this.droppedFiles.push(f)
            files++
            if (files === dataLength) {
              setTimeout(() => {
                this.upload(this.droppedFiles)
              }, 100)
            }
          })
        } else if (entry) {
          this.traverseDirectory(entry).then(_fileEntries => {
            setTimeout(() => {
              this.upload(this.droppedFiles)
            }, 100)
          })
        } else {
          this.$store.dispatch('messages', {
            type: 'info',
            status: 'error_dragdrop',
            statusMessages: {
              _error_dragdrop: {
                i18n: 'analyze.upload.error_dragdrop',
              },
            },
          })
          // console.log('item', item)
          // console.log('entry', entry)
          // https://html.spec.whatwg.org/multipage/dnd.html#dndevents
          // https://stackoverflow.com/questions/41450438/datatransferitems-getasfile-method-returning-null-for-files
          console.error('ERROR -- dragdrop upload', JSON.stringify({ item }))
        }
      }
    },
    traverseDirectory(entry) {
      const reader = entry.createReader()
      // Resolved when the entire directory is traversed
      return new Promise((resolve, reject) => {
        const iterationAttempts = []
        const readEntries = () => {
          // According to the FileSystem API spec, readEntries() must be called until
          // it calls the callback with an empty array.  Seriously??
          reader.readEntries(
            entries => {
              if (!entries.length) {
                // Done iterating this particular directory
                resolve(Promise.all(iterationAttempts))
              } else {
                // Add a list of promises for each directory entry.  If the entry is itself
                // a directory, then that promise won't resolve until it is fully traversed.
                iterationAttempts.push(
                  Promise.all(
                    entries.map(ientry => {
                      if (ientry.isFile) {
                        ientry.file(file => {
                          this.droppedFiles.push(file)
                        })
                        return ientry
                      }
                      return this.traverseDirectory(ientry)
                    }),
                  ),
                )
                // Try calling readEntries() again for the same dir, according to spec
                readEntries()
              }
            },
            error => reject(error),
          )
        }
        readEntries()
      })
    },
    handleFolderUpload() {
      const { files } = this.$refs.folder_input
      this.upload(files)
    },
    handleFileUpload() {
      const { files } = this.$refs.file_input
      this.upload(files)
    },
    resetInput() {
      this.droppedFiles = []
      if (this.$refs.upload_form) {
        this.$refs.upload_form.reset()
      }
    },
    async upload(files) {
      await this.$store.dispatch('tokenRefresh')

      const pendingUploads = this.api_uploads.filter(
        item => item.status === 'progress' || item.status === 'waiting',
      )
      this.$store.commit('messages_reset')

      if (files.length + pendingUploads.length > 1500) {
        if (this.maxFilesError) return
        this.maxFilesError = true
        this.resetInput()

        this.$store.dispatch('messages', {
          type: 'error',
          status: 'status_too_many_files',
          statusMessages: {
            _status_too_many_files: {
              i18n: 'analyze.upload.status_too_many_files',
            },
          },
        })
        return
      }

      let lFiles = []
      if (Array.isArray(files)) {
        lFiles = files
      } else {
        Object.keys(files).forEach(key => {
          lFiles.push(files[key])
        })
      }

      let okFiles = []
      lFiles.forEach(file => {
        if (!['.txt', '.xml'].some(ft => file.name.endsWith(ft))) {
          this.$store.dispatch('messages', {
            type: 'error',
            status: 'unsuported_file_type',
            preceding_text: file.name,
            statusMessages: {
              _unsuported_file_type: {
                i18n: 'analyze.upload.status_not_suported_file_type',
                i18nParams: { filetypes: '.xml, .txt' },
              },
            },
          })
        } else if (file.size > 50000000) {
          this.$store.dispatch('messages', {
            type: 'error',
            status: 'file_over_50MB',
            preceding_text: file.name,
            statusMessages: {
              _file_over_50MB: {
                i18n: 'analyze.upload.status_file_over_50MB',
              },
            },
          })
          // hidden macox files - dont show filetype err for them
        } else if (!['.DS_STORE'].some(ft => file.name.endsWith(ft))) {
          okFiles.push(file)
        }
      })

      okFiles = okFiles.map(file => ({
        file,
        callId: uuid(),
        startTime: Date.now(),
        status: 'waiting',
      }))

      this.$store.dispatch('api_add_uploads', { files: okFiles })
      this.$store.dispatch('api_upload_next_file')

      if (okFiles.length) {
        this.$store.dispatch('globals_drawer', {
          open: false,
          content: '',
        })
      }
      this.resetInput()
    },
    startPasting() {
      this.pasting = true

      nextTick(() => {
        const { paste_container } = this.$refs
        paste_container.focus()
      })
    },
    analyze() {
      this.$store.commit('messages_reset')

      const text = this.$refs.paste_container.value
      const url = 'https://blog.gtowizard.com/suported-sites-and-formats-for-hh-analyzer/'
      if (!text.trim().length) {
        this.$store.dispatch('messages', {
          type: 'error',
          status: 'empty',
          statusMessages: {
            _empty: {
              i18n: 'analyze.upload.hand.status_empty',
              link: {
                url,
                i18n: 'common.read_more_here',
              },
            },
          },
        })
        return
      }
      if (text.trim().length > 6000) {
        this.$store.dispatch('messages', {
          type: 'error',
          status: 'over_2500_chars',
          statusMessages: {
            _over_2500_chars: {
              i18n: 'analyze.upload.hand.status_over_2500_chars',
              link: {
                url,
                i18n: 'common.read_more_here',
              },
            },
          },
        })
        this.$refs.paste_container.value = ''
        return
      }
      const data = { text }
      this.$store.dispatch('api_v2_poker_hand_history_text', data)
      this.reset()
    },
    reset() {
      this.pasting = false
      this.$refs.paste_container.value = ''
    },
  },
  computed: {
    supportedFormats() {
      return [
        { name: `${this.$t('gametypes.groups.cash_long')}`, enabled: true },
        { name: this.$t('gametypes.groups.mtt_long'), enabled: true },
        { name: this.$t('gametypes.groups.spins_long'), enabled: true },
        { name: this.$t('gametypes.groups.husng_long'), enabled: true },
      ]
    },
    user_info() {
      const { user_info } = this.$store.getters
      return user_info
    },
    sub() {
      const { user_info } = this.$store.getters
      const subs = user_info.subs || []
      let sub = subs.find(i => i.plan.game_format.toLowerCase() === 'cash')
      if (!sub) {
        sub = subs.find(i => i.plan.game_format.toLowerCase() === 'any')
      }
      return sub
    },
    globals_drawer() {
      const res = this.$store.getters.globals_drawer
      return res
    },
    apiHandText() {
      const mutationKey = 'api_v2_poker_hand_history_text'
      const data = this.$store.getters.api_get(mutationKey)
      return data
    },
    loading() {
      return this.apiHandText?.loading
    },
    loaded() {
      return this.apiHandText?.loaded
    },
    api_uploads() {
      return this.$store.state.api.api_uploads
    },
    maintenanceFilesUpload() {
      return this.$store.getters.maintenanceFilesUpload
    },
    mobile() {
      return this.$store.getters.mobile
    },
  },
  watch: {
    tab() {
      this.setUploadBox()
    },
    loaded() {
      if (this.loaded) {
        this.pasting = false
      }
    },
    globals_drawer() {
      setTimeout(() => {
        this.pasting = false
      }, 333)
    },
  },
}
</script>
<style lang="scss" scoped>
@media (max-width: 1024px) {
  .analyze-upload {
    &_left,
    &_right {
      width: 100% !important;
    }
  }
}

.highlighted {
  background: var(--clr-black-1) !important;
}

.paste-text {
  text-align: left !important;
  word-break: break-all;
  overflow: hidden;
  position: relative;
  background: var(--clr-black-2) !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  textarea {
    position: relative;
    z-index: 2;
    overflow: auto;
    color: var(--clr-white-0);
    height: 100%;
    width: 100%;
    flex: 1;
    resize: none;
    padding: 0 0.5rem;
  }
  .text-area-help {
    position: relative;
    position: absolute;
    z-index: 1;
    color: var(--clr-grey-2);
    flex: 1;
  }
  &:hover {
    cursor: text !important;
  }
}
.current-uploads {
  width: 24rem;
  padding: 0 0 1rem 0;
  display: flex;
  flex-direction: column-reverse;
}
.analyze-upload {
  height: calc(100% - 3rem);
  display: flex;
  flex-direction: column;
  flex: 1;
  &_left,
  &_right {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex: 1;
    // padding-top: 1rem;
  }
  &_tabs {
    max-height: 3rem;
  }

  .upload-container {
    border-radius: 6px;
    // border-radius: 16px;
    flex: 1;
    width: 100%;
    // width: 23rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 1rem 1rem;
    text-align: center;
    background: var(--clr-black-1);
    margin: 0 0 1rem 0;
    // margin: 0 0 0.5rem 0;
    // margin: 0 0 0.75rem 0;
    border: solid var(--clr-black-4) 2px;
    transition: background 0.2s;
    position: relative;
    &:not(.paste-text, .upload-disabled) {
      &::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
      }
    }
    &_hovered:not(.upload-disabled) {
      background: var(--clr-black-2);
    }
    &:hover:not(.upload-disabled) {
      cursor: pointer;
      background: var(--clr-black-2);
    }
    .text-message {
      font-size: 1rem;
      font-weight: 700;
    }
  }

  .dashed {
    border: dashed var(--clr-black-4) 2px !important;
  }
  &_icon {
    font-size: 4rem;
    color: var(--clr-grey-2);
    margin-bottom: 0.5rem;
  }
}
.btn-upload {
  width: 10rem;
}
</style>
